<template>
	<layout-gestao>
		<div class="row">
			<div class="col-sm-12">
				<form
					autocomplete="off"
					method="post"
					:disabled="isLoading"
					data-vv-scope="form"
					@submit.prevent="saveItem"
					>
					<div class="row mb-3">
						<div class="col-sm-auto">
						<h1 class="content-title">
							{{ titleItem }}
						</h1>
						</div>
					</div>
					<div class="row">
						<div class="col-12 col-md-6">
							<MaterialSelect
								id="input-parent_id"
								v-model.trim="form.parent_id"
								v-validate="''"
								:disabled="readonlyFormItem"
								class="city-form-group city-bg"
								name="parent_id"
								label="name"
								:filterable="true"
								:reduce="(item) => item.id"
								:options="lists.parents"
								:inputClasses="[{'is-invalid': fnHasError('parent_id') }]">
								{{ $t(`${pageID}.model.parent`) }}
							</MaterialSelect>
						</div>
						<div class="col-12 col-md-3">
							<MaterialInput
								id="input-order"
								v-model.trim="form.order"
								v-validate="'required|integer|min_value:1'"
								:readonly="readonlyFormItem"
								type="number"
								class="city-form-group city-bg"
								name="order"
								:inputClasses="[{'is-invalid': fnHasError(`order`) }]"
								:error="fnFirstError(`order`)">
								{{ $t(`${pageID}.model.order`) }}
							</MaterialInput>
						</div>
						<div class="col-12 col-md-3">
							<MaterialSelect
								id="input-status"
								v-model.trim="form.status"
								v-validate="'required'"
								:disabled="readonlyFormItem"
								class="city-form-group city-bg"
								name="status"
								label="name"
								:filterable="true"
								:options="lists.onoff"
								:reduce="option => option.code"
								:inputClasses="[{'is-invalid': fnHasError('status') }]"
								:error=" fnFirstError('status')">
								{{ $t(`${pageID}.model.status`) }}
							</MaterialSelect>
						</div>
					</div>
					<div class="row">
						<div class="col-12">
							<MaterialInput
								id="input-name"
								v-model.trim="form.name"
								v-validate="'required|max:250'"
								:readonly="readonlyFormItem"
								type="text"
								class="city-form-group city-bg"
								name="name"
								:inputClasses="[{'is-invalid': fnHasError(`name`) }]"
								:error="fnFirstError(`name`)">
								{{ $t(`${pageID}.model.name`) }}
							</MaterialInput>
						</div>
					</div>
					<buttons-footer
						:enableButtons="!readonlyFormItem"
						:cancelTitle="cancelTitle"
						:submitTitle="submitTitle"
						:isDisabled="isDisabled"
						@save="saveItem"
						@cancel="handleBack(`${moduleInternalCode}.${pageID}`)"
					/>
				</form>
			</div>
		</div>
	</layout-gestao>
</template>

<script>
	import mixin from '../../../../mixin';

	export default {
		mixins: [mixin],
		data() {
			return {
				pageID: 'parish_interventions_types',
				form: {
					id: null,
					parent_id: null,
					name: null,
					order: 1,
					status: 1
				},
			}
		},
		beforeMount: function() {
			this.loadLists();
		},
		methods: {
			loadLists() {
				this.$http.get(this.url.getLists).then(({data}) => {
					this.lists = {...this.lists, ...data, loaded: true};
				}).catch(error => {
					this.showHttpError(error);
				});
			},
		}
	}
</script>